import { useQuery } from '@tanstack/react-query';
import { queryFn } from './watchlistsQueryFn';

export const QUERY_KEY = ['WATCHLISTS'] as const;

export function useWatchlists() {
  const query = useQuery({
    queryKey: QUERY_KEY,
    queryFn,
    staleTime: 3600000,
    retry: 1,
  });

  return query;
}
